import React from 'react';
import { ProjectFeed } from '@pages/projects/components/ProjectFeed';
import { FeedSkeletonList } from '@components/organisms/FeedSkeletonList';
import { EmptyData } from '@components/molecules/EmptyData';
import { useTranslation } from '@hooks/useTranslation';

interface ProjectFeedWithLoadingProps {
  activities: any[];
  paginationActions: any;
  totalCount: number;
  isLoading?: boolean;
  handleOpenTaskDetail: (taskId: string) => void;
  onProjectClick?: (projectId: string) => void;
}

export const ProjectFeedWithLoading: React.FC<ProjectFeedWithLoadingProps> = ({
  activities,
  paginationActions,
  totalCount,
  isLoading = false,
  handleOpenTaskDetail,
  onProjectClick,
}) => {
  const tDashboard = useTranslation('dashboard');
  // Show loading state for initial load — skeleton feed instead of a spinner.
  if (isLoading) {
    return (
      <div className="w-full" style={{ minHeight: '400px' }}>
        <FeedSkeletonList />
      </div>
    );
  }

  // Show empty state when no activities
  if (!isLoading && activities.length === 0) {
    return (
      <div className="w-full">
        <EmptyData description={tDashboard.noActivitiesToDisplay} fullHeight />
      </div>
    );
  }

  // Show the actual feed
  return (
    <ProjectFeed
      activities={activities}
      paginationActions={paginationActions}
      totalCount={totalCount}
      handleOpenTaskDetail={handleOpenTaskDetail}
      onProjectClick={onProjectClick}
    />
  );
};
